import {ReactElement} from "react";
import {ThemeProvider} from "@zendeskgarden/react-theming";
import {ViziblyTheme} from "../../styles/zendesk-garden/ViziblyZDGTheme";
import {Col, Grid, Row} from "@zendeskgarden/react-grid";
import * as css from "./styles/LogInLogOutLoader.module.scss";
import loginGraphic from "./loginGraphic";
import {Dots} from "@zendeskgarden/react-loaders";

export interface LogInLogOutLoaderProps {
    text: string;
    image?: ReactElement;
}

export function LogInLogOutLoader(props: LogInLogOutLoaderProps): ReactElement {
    return <ThemeProvider theme={ViziblyTheme}>
        <div className={css.logInLogOutPage}>
            <Grid>
                <Row className={css.row}>
                    <Col>
                        <div className={css.text}>
                            <div>
                                <div>{props.image ? props.image : ""}</div>
                                {props.text}&nbsp;<Dots size={32} />
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className={css.loginImage}>
                            <img src={loginGraphic} alt="assestsPerformance"/>
                            <div className={css.optimizeText}>Optimize the performance of <br/> your assets.</div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        </div>
    </ThemeProvider>;
}